var map = {
	"./Contact-scaled.jpg": 5155,
	"./HD-wallpaper-mountain-view-from-top-mountains-nature.jpg": 7707,
	"./Task-mgmt.jpeg": 954,
	"./books.jpg": 2552,
	"./doc1.jpg": 3715,
	"./doc2.jpg": 1287,
	"./doc3.jpg": 1713,
	"./doc4.jpg": 18,
	"./doc5.jpg": 8780,
	"./doc6.jpg": 3408,
	"./doc7.jpg": 8973,
	"./doc8.jpg": 1230,
	"./doc9.jpg": 2539,
	"./gentle-piano.mp3": 2219,
	"./high-frequency.mp3": 413,
	"./jasper-lake.webp": 7311,
	"./jasper-lake1.webp": 4769,
	"./ocean-waves.mp3": 3455,
	"./rainforest.mp3": 8513,
	"./sunrise-over-the-mountains-14574-1920x1200.jpg": 5441,
	"./win.jpg": 3248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2098;